



















































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
  data: ->
    show: false
    setting: if Session.current_user.vtiger_setting.id? then Session.current_user.vtiger_setting else new VtigerSetting()
    lead: false
    contact: false

  methods:
    sending_checked: (option) ->
      @lead = @contact = false

      @lead = true if option == 'lead'
      @contact = true if option == 'contact'

    open: ->
      @show = !@show

    close: ->
      @show = false

    save: ->
      @$validator.validateAll().then (success) =>
        @updateUser() if success

    updateUser: ->
      Loader.on()
      mark_as = 'lead' if @lead
      mark_as = 'contact' if @contact

      params = {
        id: Session.current_user.id,
        vtiger_setting_attributes: {
          id: @setting.id,
          mark_as: mark_as,
          access_key: @setting.access_key,
          username: @setting.username,
          url: @setting.url,
          triggers: @setting.triggers
        }
      }
      new UsersResource().update(@updateUserSuccess, @handleApiErrors, params)

    updateUserSuccess: (data, response) ->
      Loader.off()
      message_action = if data.user.vtiger_setting.id then this.$t('general.actions.connectedTo') else this.$t('general.actions.disconnectedTo')
      alertify.success this.$t('integrations.label.vtiger.success')
      Session.signIn(response.body.user)
      @current_user = Session.current_user
      @close()

    setStages: (data) ->
      @setting.triggers = data

    loadVtigerFields: ->
      @lead = true if @setting.mark_as == 'lead' || @setting.mark_as == null
      @contact = true if @setting.mark_as == 'contact'

  mounted: ->
    @loadVtigerFields()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/vtiger.vue